import {postRequest} from '../libs/AxiosService.util';
import Constants from "../config/constants";

export async function serviceCreateGeofence(params) {
    return await postRequest('geofences/create', params, Constants.DOCTOR_APP_API_URL);
}

export async function serviceUpdateGeofence(params) {
    return await postRequest('geofences/update', params, Constants.DOCTOR_APP_API_URL);
}

export async function serviceDeleteGeofence(params) {
    return await postRequest('geofences/delete', params, Constants.DOCTOR_APP_API_URL);
}

export async function serviceGetGeofence (params) {
    return await postRequest('geofences', params, Constants.DOCTOR_APP_API_URL);
}

export async function serviceGetGeofenceList (params) {
    return await postRequest('geofences', params, Constants.DOCTOR_APP_API_URL);
}

export async function serviceGeofenceCheck (params) {
    return await postRequest('geofence/check', params, Constants.DOCTOR_APP_API_URL);
}
export async function serviceGetGeofenceDetails (params) {

    return await postRequest('geofence/detail', params, Constants.DOCTOR_APP_API_URL);
}

